import { render, staticRenderFns } from "./coalDetailstwo.vue?vue&type=template&id=6ec2743a&scoped=true&"
import script from "./coalDetailstwo.vue?vue&type=script&lang=js&"
export * from "./coalDetailstwo.vue?vue&type=script&lang=js&"
import style0 from "./coalDetailstwo.vue?vue&type=style&index=0&id=6ec2743a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2743a",
  null
  
)

export default component.exports